module.exports = __webpack_public_path__ + "static/media/icon_love_off.2bf54c1f.svg";